import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { IDevice } from '@/api/routes/devices/types';
import type { ResponseWithPagination } from '@/utils/types';

import { fetchDevices } from './actionCreators';

interface InitialState {
  devices: IDevice [],
  isLoading: boolean,
  offset: number,
  totalCount: number,
  error: string,
  updatedAt: number,
}

const initialState: InitialState = {
  devices: [],
  offset: 0,
  totalCount: 0,
  isLoading: false,
  error: '',
  updatedAt: 0,
};

export const devicesSlice = createSlice({
  name: 'devices',
  initialState,
  reducers: {
    addDevice: (state, action: PayloadAction<IDevice>) => {
      state.devices = state.devices.concat(action.payload);
    },
    updateDevice: (state, action: PayloadAction<IDevice>) => {
      const deviceIndex = state.devices.findIndex((el) => el.id === action.payload.id);
      state.devices[deviceIndex] = action.payload;
    },
    deleteDevice: (state, action: PayloadAction<IDevice>) => {
      state.devices = state.devices.filter((device) => device.id !== action.payload.id);
    },
  },
  extraReducers: {
    [fetchDevices.fulfilled.type]: (state, action: PayloadAction<ResponseWithPagination<IDevice>>) => {
      state.isLoading = false;
      state.error = '';
      state.devices = action.payload.rows;
      state.offset = action.payload.offset;
      state.totalCount = action.payload.total_count;
      state.updatedAt = Date.now();
    },
    [fetchDevices.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchDevices.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  updateDevice,
  deleteDevice,
  addDevice,
} = devicesSlice.actions;
export default devicesSlice.reducer;
